"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestStatus = exports.requestErrors = void 0;
var requestStatus = exports.requestStatus = function (requestStatus) {
  requestStatus["success"] = "success";
  requestStatus["fail"] = "fail";
  return requestStatus;
}({});
var requestErrors = exports.requestErrors = function (requestErrors) {
  requestErrors["generic"] = "generic";
  requestErrors["lastTravelManager"] = "2518";
  requestErrors["currentPasswordNotMatch"] = "037";
  return requestErrors;
}({});